// @module NXTurn.ShoppingExtensions.PDP
define('C3.ShoppingExtensions.CartPage.Wishlist.Rightside.ListControl.NewItem.View'
,   [
        'c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_newitem.tpl',
        'Backbone.FormView'
    ]
, function (
        c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_newitem_tpl,
        BackboneFormView
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.PDP.View @extends Backbone.View
    return Backbone.View.extend({

    tagName: 'div',

    template: c3_shoppingextensions_cartpage_wishlist_rightside_listcontrol_newitem_tpl,

    events: {
        'submit [data-action="create-and-move"]': 'createMoveList',
        'click [data-action="show-add-new-list-form"]': 'showNewListForm'
    },

    bindings: {
        '[name="name"]': 'name'
    },

    initialize: function (options) {
        this.application = options.application;
        this.model = options.model;
        this.parentView = options.parentView;

        //console.log(options)

        BackboneFormView.add(this);
    },

    // Handle save new product list form postback
    createMoveList: function(event) {
        event.stopPropagation();
        event.preventDefault();

        if (!this.parentView.validateGiftCertificate(this.parentView.product)) {
            return;
        }
        const self = this;
        const save_promise = this.saveForm(event);

        if (!save_promise) {
            return;
        }

        save_promise.done(function() {
            const new_product_list = self.model;
            const parent_view = self.parentView;

            // add the product list item
            if (parent_view.mode === 'move') {
                // create new list
                self.application.ProductListModule.Utils.getProductLists().add(new_product_list);
                parent_view.moveProductHandler(new_product_list).then(() => {
                    parent_view.collection.add(self.model, { merge: true });
                    self.application.ProductListModule.Utils.updateProductListMenu();
                });
            } else {
                parent_view.collection.add(new_product_list);
                parent_view.addNewProductToList(new_product_list).then(() => {
                    self.application.ProductListModule.Utils.updateProductListMenu();
                });
            }
        });
    },

    // @method showNewListForm Shows the create new list form
    showNewListForm: function(e) {
        e && e.stopPropagation();
        const $el = jQuery(this.el);
        const new_list_form = $el.find('form[data-type="product-list-control-add-new-list-form"]');

        if (new_list_form) {
            new_list_form.show();
            this.$('[data-type="new-product-list-name"]').focus();
            $el.find('.create-new-wishlist').hide();
            //$el.find(e.target).hide();
        }
    },
     

        //@method getContext @return NXTurn.ShoppingExtensions.PDP.View.Context
    getContext: function getContext()
        {         
            return {
              isMoving: this.parentView.mode === 'move'  
            };
        }
    });
});
